import { CanNTalkBootstrapSchema, CanNTalkSessionSchema, type CanNTalkBehaviorProfile } from '../../shared/canntalk';
import { ApiError } from '../lib/api';

export class CanNTalkRequestError extends ApiError {
  constructor(message: string, status: number, public code?: string, public retryable = false) { super(message, status); }
}

export type AISettings = { provider: 'qwen' | 'openai'; model: string; keyConfigured: boolean; editable: boolean };

async function request(path: string, init?: RequestInit): Promise<unknown> {
  const response = await fetch(`/api/canntalk${path}`, {
    credentials: 'include', ...init,
    headers: init?.body ? { 'Content-Type': 'application/json', ...init.headers } : init?.headers,
  });
  if (!response.ok) {
    if (response.status === 401) window.dispatchEvent(new Event('canntalk-auth-expired'));
    const body = await response.json().catch(() => ({ error: '未能完成請求，請再試。' }));
    throw new CanNTalkRequestError(body.error || '未能完成請求，請再試。', response.status, body.code, body.retryable === true);
  }
  return response.json();
}
export async function getCanNTalkBootstrap() { return CanNTalkBootstrapSchema.parse(await request('/bootstrap')); }
export async function getPracticeSession(id: string) { return CanNTalkSessionSchema.parse(await request(`/sessions/${encodeURIComponent(id)}`)); }
export async function createPracticeSession(body: { scenarioId: string; avatarCount: 1 | 2 | 3; avatarIds?: string[]; profiles: Record<string, CanNTalkBehaviorProfile>; mode?: 'live' | 'demo'; consent: { version: string; accepted: true } }) {
  return CanNTalkSessionSchema.parse(await request('/sessions', { method: 'POST', body: JSON.stringify(body) }));
}
export async function sendPracticeTurn(id: string, text: string, submission?: { requestId: string; expectedTurnCount: number; interruptedByAvatarId?: string }) {
  return CanNTalkSessionSchema.parse(await request(`/sessions/${encodeURIComponent(id)}/turns`, { method: 'POST', body: JSON.stringify({ text, ...submission }) }));
}

export async function getAISettings(): Promise<AISettings> { return await request('/ai-settings') as AISettings; }
export async function saveAISettings(body: { provider: AISettings['provider']; model: string; apiKey?: string }): Promise<AISettings> {
  return await request('/ai-settings', { method: 'PUT', body: JSON.stringify(body) }) as AISettings;
}
export async function completePracticeSession(id: string) {
  return CanNTalkSessionSchema.parse(await request(`/sessions/${encodeURIComponent(id)}/complete`, { method: 'POST' }));
}
